import { render, staticRenderFns } from "./PedidoEnvioFornecedor.vue?vue&type=template&id=4041f360&scoped=true"
import script from "./PedidoEnvioFornecedor.vue?vue&type=script&lang=js"
export * from "./PedidoEnvioFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041f360",
  null
  
)

export default component.exports